var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.page?("page-" + _vm.page):'','lang-'+_vm.lang]},[_c('div',{staticClass:"cpj-wrapper",style:(_vm.wrapperStyle)},[_c('nuxt')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }